import React from "react";
import styled from "styled-components";
import statistics from "../../assets/statistics.png";
import filter from "../../assets/filter.png";
import uploadFileWhite from "../../assets/uploadFileWhite.png";
import SearchBar from "../common/Search/SearchBar";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  padding-left: 30px;
  background-color: #FFFEF9;
  border-bottom: 1px solid #ddd;
  width: 100%;
`;

const Text = styled.div`
  display: flex;
  align-items: center;
`;

const TextAndButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  background-color: #6AB8A8;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  cursor: pointer;

  img {
    margin-left: 10px;
    width: 20px;
    height: 20px;
  }

  span {
    font-size: 18px;
    margin-left: 10px;
  }
`;

const WelcomeText = styled.div`
  font-size: 18px; /* Tamanho padronizado */
  color: #002E3B;
  font-weight: 600;
  margin-left: 15px;
  margin-top: 14px;
`;

const SearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 40px;
`;

const BemVindoWrapper = styled.div`
  @media (max-width: 768px) {
    padding-top: 50px;
  }
`;

const BemVindoComponent = () => {
  return (
    <BemVindoWrapper>
      <Container>
      <TextAndButtons>
          <Text>
            <WelcomeText>RELATÓRIO DE VAGAS</WelcomeText>
            <img src={statistics} alt="Especialidades" style={{ marginLeft: "10px", width: "40px", height: "40px", marginTop: "5px" }} />
          </Text>
          <Button>
            Filtrar
            <img src={filter} alt="Filtrar" />
          </Button>
          <Button>
            Ordenar
            <span className="material-symbols-outlined" style={{ width: "20px", height: "20px", fontSize: "20px" }}>toc</span>
          </Button>
          <Button style={{backgroundColor: "#FF9F1F"}}>
            Gerar PDF
            <span className="material-symbols-outlined" style={{ width: "20px", height: "20px", fontSize: "20px" }}>upload</span>
          </Button>
        </TextAndButtons>

        <SearchBarWrapper>
          <SearchBar />
        </SearchBarWrapper>
      </Container>
    </BemVindoWrapper>
  );
};

export default BemVindoComponent;